// extracted by mini-css-extract-plugin
export default {"header":"header--dTVCw","simple-arrow-accordion":"simple-arrow-accordion--ojb1b","simpleArrowAccordion":"simple-arrow-accordion--ojb1b","body":"body--veeMt"};